import { ICompany, ICreateCompany } from '.'
import { IPaginatedRequest } from '@cbgms/api/request'

export const createInitialCompany = (data: ICreateCompany) => ({
  method: 'POST',
  url: `/setup/initial-company-setup`,
  data
})

export const getUserCompany = () => ({
  method: 'GET',
  url: '/modules/company'
})

export const updateUserCompany = (data: Partial<ICompany>) => ({
  method: 'PUT',
  url: '/modules/company',
  data
})

export const listCompanies = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/companies',
  params
})

export const getCompany = (UUID: string) => ({
  method: 'GET',
  url: `/modules/companies/${UUID}`
})

export const createCompany = (data: Partial<ICompany>) => ({
  method: 'POST',
  url: '/modules/companies',
  data
})

export const updateCompany = (UUID: string, data: Partial<ICompany>) => ({
  method: 'PUT',
  url: `/modules/companies/${UUID}`,
  data
})

export const supportListCompanies = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/support/companies',
  params
})

export const supportGetCompany = (companyUUID: string) => ({
  method: 'GET',
  url: `/support/companies/${companyUUID}`
})

export const supportCreateCompany = (data: Partial<ICompany>) => ({
  method: 'POST',
  url: '/support/companies',
  data
})

export const supportUpdateCompany = (companyUUID: string, data: Partial<ICompany>) => ({
  method: 'PUT',
  url: `/support/companies/${companyUUID}`,
  data
})
